import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchNCFs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('purchase/vendors/ncf/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteNCF(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`purchase/ncf/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
